export default __webpack_public_path__ + "static/media/OlmoMathilda_MS_Still_1.4daae528.jpg";